import { Component } from '@angular/core';
import { Router, NavigationEnd} from '@angular/router'
import { environment } from '../environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'app';
  loading = true;
  constructor(private router: Router) {
    if (environment.IsGAEnabled) {
      // register google tag manager
      const gTagManagerScript = document.createElement('script');
      gTagManagerScript.async = true;
      gTagManagerScript.src = `https://www.googletagmanager.com/gtag/js?id=${environment.GAAccount}`;
      document.head.appendChild(gTagManagerScript);
  
      // register google analytics
      const gaScript = document.createElement('script');
      gaScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        gtag('config', '${environment.GAAccount}');
      `;
      document.head.appendChild(gaScript);
      console.log('GA Testing.......');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts